<div class="inner-navigation">
  <div class="back" (click)="navigateBack()">
    <p class="text-button-small">{{ 'chat-claim-details.back-button' | translate }}</p>
  </div>
</div>

<div class="detail-title">
  <div class="status online">
    <p class="tag-12">{{ getStatusText() }}</p>
  </div>

  <div class="title">
    <h4>{{ getTitle() }}</h4>
  </div>
</div>

@if (detailItem?.type === 'chat') {
  <div class="details-part info">
    <div class="row">
      <div class="vertical">
        <div class="title">
          <p class="body-12">{{ 'chat-claim-details.fields.topic' | translate }}</p>
        </div>
        <div class="value">
          <p class="subtitle-14">{{ getChatData()?.medical_category || ('chat-claim-details.fallbacks.general-consultation' | translate) }}</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="vertical">
        <div class="title">
          <p class="body-12">{{ 'chat-claim-details.fields.consultation-date' | translate }}</p>
        </div>
        <div class="value">
          <p class="subtitle-14">{{ $safeNavigationMigration(getChatData()?.created_at) | date: 'dd.MM.yyyy' }}</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="vertical">
        <div class="title">
          <p class="body-12">{{ 'chat-claim-details.fields.summary' | translate }}</p>
        </div>
        <div class="value">
          <p class="subtitle-14">{{ getChatData()?.summary || ('chat-claim-details.fallbacks.no-summary' | translate) }}</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="vertical">
        <div class="title">
          <p class="body-12">{{ 'chat-claim-details.fields.symptoms' | translate }}</p>
        </div>
        <div class="value">
          <p class="subtitle-14">{{ getSymptomsText() }}</p>
        </div>
      </div>
    </div>
  </div>
}

@if (detailItem?.type === 'claim') {
  <div class="details-part info">
    <div class="row">
      <div class="vertical">
        <div class="title">
          <p class="body-12">{{ 'chat-claim-details.fields.cause' | translate }}</p>
        </div>
        <div class="value">
          <p class="subtitle-14">{{ detailItem?.title }}</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="vertical">
        <div class="title">
          <p class="body-12">{{ 'chat-claim-details.fields.consultation-date' | translate }}</p>
        </div>
        <div class="value">
          <p class="subtitle-14">{{ $safeNavigationMigration(getClaimData()?.claim_date) | date: 'dd.MM.yyyy' }}</p>
        </div>
      </div>
    </div>
  </div>
}
